import { styled } from 'linaria/react';
import React, { FC, PropsWithChildren } from 'react';
const Title: FC<PropsWithChildren<{
  color?: 'light' | 'dark';
  isResult?: boolean;
  as?: 'h1' | 'h2';
}>> = ({
  color = 'light',
  isResult = false,
  as = 'h2',
  children
}) => <TitleWrapper as={as} isResult={isResult} color={color}>
    {children}
  </TitleWrapper>;
export default Title;
const _exp = /*#__PURE__*/() => ({
  isResult
}) => isResult ? '3.75vw' : '4.5em';
const _exp2 = /*#__PURE__*/() => ({
  color
}) => color === 'light' ? '#fff' : '#2C3135';
const _exp3 = /*#__PURE__*/() => ({
  isResult
}) => isResult ? '3.75vw' : '56px';
const TitleWrapper = /*#__PURE__*/styled('h2')({
  name: "TitleWrapper",
  class: "tj2on5a",
  propsAsIs: false,
  vars: {
    "tj2on5a-0": [_exp()],
    "tj2on5a-1": [_exp2()],
    "tj2on5a-2": [_exp3()]
  }
});

require("./Title.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./Title.tsx");